import { useState } from "react";
import ExploreItemModal from "./ExploreItemModal";

export default function VideoDisplay({
  items,
  handleMarkAsDone,
  markedItems,
  progressKeyPrefix = "lectureItem",
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalUrl, setModalUrl] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [isHovered, setIsHovered] = useState(-1);

  return (
    <div>
      {!items ? (
        <div className="d-flex flex-column align-items-center pt-5">
          <h4 className="mb-3 text-center text-secondary">
            Please select options from the left panel and click Search to load a
            video.
          </h4>
        </div>
      ) : (
        <div className="d-flex flex-column">
          {items.length === 0 && (
            <h5 className="mb-3 text-start text-secondary">
              No videos available for the selected options.
            </h5>
          )}
          {items.map((item, idx) => {
            const videoUrl = item.url;
            const progressKey = `${progressKeyPrefix}:${item.id}`;
            const match = videoUrl.match(
              /(?:youtu\.be\/|youtube\.com\/(?:.*[?&]v=|embed\/|v\/|live\/))([A-Za-z0-9_-]{11})/,
            );
            const videoId = match ? match[1] : null;
            const checked = markedItems && markedItems.includes(progressKey);

            let embedUrl = null;

            if (videoId) {
              embedUrl = `https://www.youtube.com/embed/${videoId}`;
            } else if (videoUrl.includes("/live/")) {
              const channelMatch = videoUrl.match(/channel\/([A-Za-z0-9_-]+)/);
              if (channelMatch) {
                const channelId = channelMatch[1];
                embedUrl = `https://www.youtube.com/embed/live_stream?channel=${channelId}`;
              }
            }

            return (
              <div key={item.id} style={{ width: "100%", marginBottom: "12px" }}>
                {embedUrl ? (
                  <div
                    onClick={() => {
                      setModalUrl(embedUrl);
                      setModalTitle(item.description);
                      setModalOpen(true);
                    }}
                    onMouseEnter={() => setIsHovered(idx)}
                    onMouseLeave={() => setIsHovered(-1)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      borderRadius: "12px",
                      background:
                        isHovered === idx
                          ? "linear-gradient(135deg, #f5f9ff, #edf6ff)"
                          : "#ffffff",
                      border: "1px solid #eef2f5",
                      boxShadow:
                        isHovered === idx
                          ? "0 8px 20px rgba(52,152,219,0.15)"
                          : "0 2px 6px rgba(0,0,0,0.05)",
                      cursor: "pointer",
                      transition: "all 0.25s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "10px",
                          background: "rgba(52,152,219,0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i
                          className="fa-solid fa-video"
                          style={{
                            color: "#3498db",
                            fontSize: "0.9rem",
                          }}
                        />
                      </div>

                      <div
                        style={{
                          fontSize: "0.95rem",
                          fontWeight: "600",
                          color: "#2c3e50",
                        }}
                      >
                        {item.description}
                      </div>
                    </div>

                    {handleMarkAsDone && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleMarkAsDone(progressKey, !checked);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          cursor: "pointer",
                          padding: "4px 8px",
                          borderRadius: "6px",
                          background: checked ? "#d4edda" : "#f8f9fa",
                          border: `1px solid ${checked ? "#c3e6cb" : "#dee2e6"}`,
                          transition: "all 0.2s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = checked
                            ? "#c3e6cb"
                            : "#e9ecef";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = checked
                            ? "#d4edda"
                            : "#f8f9fa";
                        }}
                      >
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            borderRadius: "3px",
                            border: `2px solid ${checked ? "#28a745" : "#6c757d"}`,
                            background: checked ? "#28a745" : "transparent",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {checked && (
                            <i
                              className="fa-solid fa-check"
                              style={{
                                color: "white",
                                fontSize: "10px",
                              }}
                            />
                          )}
                        </div>
                        <span
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            color: checked ? "#155724" : "#495057",
                          }}
                        >
                          {checked ? "Completed" : "Mark Complete"}
                        </span>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ color: "red" }}>
                    Invalid video URL: {videoUrl}
                  </div>
                )}

                {modalOpen && (
                  <ExploreItemModal
                    onClose={() => setModalOpen(false)}
                    isVideo={true}
                    url={modalUrl}
                    title={modalTitle}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
